/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize Recommended By SchedulingView.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './RecommendedBySchedulingView';

export const mapStateToPropsRecommendedByScheduling = mapStateToProps;
export const mapDispatchToPropsRecommendedByScheduling = mapDispatchToProps;

export default connect(
  mapStateToPropsRecommendedByScheduling,
  mapDispatchToPropsRecommendedByScheduling
)(View);
